import React from "react";
import { FiExternalLink, FiActivity, FiGitBranch, FiUsers } from "react-icons/fi";
import "./ProductInsights.css";

const POSTHOG_APP = "https://us.posthog.com";

const links = [
  {
    title: "Product Analytics home",
    description: "Live events, persons, and session overview for India Casting Club.",
    href: POSTHOG_APP,
    icon: FiActivity,
  },
  {
    title: "Funnels",
    description:
      "Build Signup → OTP → Profile → Apply and Upgrade → Checkout → Payment success funnels.",
    href: `${POSTHOG_APP}/insights?insight=FUNNELS`,
    icon: FiGitBranch,
  },
  {
    title: "User paths",
    description: "See where members go next and where they drop off (filter by platform).",
    href: `${POSTHOG_APP}/insights?insight=PATHS`,
    icon: FiUsers,
  },
  {
    title: "Session replay & heatmaps",
    description: "Watch sampled sessions and click heatmaps (web). Keep sampling on Free tier.",
    href: `${POSTHOG_APP}/replay`,
    icon: FiExternalLink,
  },
];

const ProductInsights = () => {
  return (
    <div className="childnav-content product-insights-page">
      <div className="product-insights-header">
        <h2>Product Insights</h2>
        <p>
          CEO behavior analytics for web and app (clicks, time spent, paths, drop-offs)
          live in PostHog. Open the links below after events start flowing from
          indiacastingclub.com and the mobile app.
        </p>
      </div>

      <div className="product-insights-checklist">
        <h3>Suggested CEO dashboards to create in PostHog</h3>
        <ol>
          <li>Funnel: Signup → OTP verified → First audition apply</li>
          <li>Funnel: Upgrade viewed → Checkout started → Payment success</li>
          <li>Paths from Home / Feed (filter <code>platform</code> = web | ios | android)</li>
          <li>Retention by <code>is_pro</code></li>
          <li>Top <code>cta_clicked</code> and apply drop-off by step</li>
        </ol>
      </div>

      <div className="product-insights-grid">
        {links.map((item) => {
          const Icon = item.icon;
          return (
            <a
              key={item.title}
              className="product-insights-card"
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon size={22} />
              <div>
                <h4>
                  {item.title} <FiExternalLink size={14} />
                </h4>
                <p>{item.description}</p>
              </div>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export { ProductInsights };
